import { useV2ListClientLocationsForClientQuery } from "@generated";
import type { ClientLocation } from "../types";

// Lists a client's active locations, alphabetical by name (the v2 endpoint has
// no sort param, so we sort client-side).
export const useClientLocations = (clientId: string) => {
  const { data, error, isLoading, isFetching, refetch } =
    useV2ListClientLocationsForClientQuery(
      {
        clientId: clientId,
        filter: { active: true },
        page: { size: 100 },
      },
      { refetchOnMountOrArgChange: true }
    );

  const rows: ClientLocation[] = (data?.data ?? [])
    .map((l) => ({
      id: String(l.id),
      name: l.attributes?.name ?? "",
      street: l.attributes?.street,
      street2: l.attributes?.street2,
      city: l.attributes?.city,
      state: l.attributes?.state,
      postalCode: l.attributes?.["postal-code"],
      country: l.attributes?.country,
    }))
    .sort((a, b) => a.name.localeCompare(b.name));

  return { rows, error, isLoading, isFetching, refetch };
};

export default useClientLocations;
